import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../../services/theme.service';
import { TimeService } from '../../services/time.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header.html',
  styleUrl: './header.scss'
})
export class HeaderComponent {
  @Input() sidebarOpen = false;
  @Output() sidebarToggle = new EventEmitter<void>();

  constructor(
    public themeService: ThemeService,
    public timeService: TimeService
  ) {}

  onSidebarToggle(): void {
    this.sidebarToggle.emit();
  }

  toggleTheme() {
    this.themeService.toggleTheme();
  }

  get isDarkMode(): boolean {
    return this.themeService.isDarkMode();
  }

  get currentTime(): string {
    return this.timeService.currentTime();
  }
}
